import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../services/actor.service';
import { AppData } from '../../../../models/appdata';
import { GetMasterObservationsRequest, ObservationData, SaveObservationsInfoRequest } from '../../../../models/lab/testinfo.model';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';

@Component({
  selector: 'ngbeditobservation',
  templateUrl: './editobservation.modal.html',
  styleUrls: ['./editobservation.modal.scss']
})

export class NgbEditObservationModal implements OnInit {
  @Input() ObservationsList: ObservationData[] = [];
  @Input() MasterObservations: any[] = [];
  @Input() TestName: string = 'BHCG';

  public ShowList: boolean = true; 
  public observations: ObservationData[] = [];
  public masterObservations: any[] = [];
  public filteredMasterObservations: any[] = [];
  public searchTitle: string = 'Search Observation';
  
  constructor(
    public activeModal: NgbActiveModal,
    private actorService: ActorService,
    private toastrService: NGXToastrService
  ) { }

  ngOnInit() {
    if (this.ObservationsList && this.ObservationsList.length > 0) {
      this.observations = JSON.parse(JSON.stringify(this.ObservationsList));
    } else {
      this.observations = [
        { OrderSeq: 1, Name: 'A/G RATIO', ExaminationType: 'Investigation', UOM: 'Ratio', ObservationGroup: 'Default' },
        { OrderSeq: 2, Name: 'ALBUMIN', ExaminationType: 'Investigation', UOM: 'g/dL', ObservationGroup: 'Default' }
      ];
    }

    if (this.MasterObservations && this.MasterObservations.length > 20) {
      this.masterObservations = [...this.MasterObservations];
      this.filteredMasterObservations = [...this.masterObservations];
    } else {
      this.loadMasterObservations();
    }
  }

  loadMasterObservations(searchText: string = '') {
    const req = new GetMasterObservationsRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.SearchText = searchText;

    this.actorService.GetMasterObservations(req).subscribe(
      (result) => {
        if (result && !result.hasError && Array.isArray(result.Result)) {
          this.masterObservations = result.Result;
          this.filteredMasterObservations = [...this.masterObservations];
        }
      },
      (error) => {
        if (!this.masterObservations || this.masterObservations.length === 0) {
          this.masterObservations = [
            { Code: 1, Name: 'A/G RATIO', ShortName: 'A/GR' },
            { Code: 2, Name: 'AFTER 2 HR BLOOD SUGAR', ShortName: '2HRBS' },
            { Code: 3, Name: 'ALK. PHOSPHATASE', ShortName: 'ALKPH' },
            { Code: 4, Name: 'APPEARANCE', ShortName: 'APP' },
            { Code: 5, Name: 'BACTERIA', ShortName: 'BACT' },
            { Code: 6, Name: 'BASOPHILS', ShortName: 'BASO' },
            { Code: 7, Name: 'BILE PIGMENT', ShortName: 'BILEPIG' },
            { Code: 8, Name: 'BILE SALT', ShortName: 'BILESALT' },
            { Code: 9, Name: 'BLEEDING TIME', ShortName: 'BLTIME' },
            { Code: 10, Name: 'BLOOD', ShortName: 'BLOOD' },
            { Code: 11, Name: 'BLOOD UREA', ShortName: 'BLUREA' },
            { Code: 12, Name: 'CASTS', ShortName: 'CASTS' },
            { Code: 13, Name: 'CHLORIDE (CL-)', ShortName: 'CHL' },
            { Code: 14, Name: 'CLOTTING TIME', ShortName: 'CLTIME' },
            { Code: 15, Name: 'COLOUR', ShortName: 'CLR' },
            { Code: 16, Name: 'COMPLETE BLOOD COUNT', ShortName: 'CBC' }
          ];
          this.filteredMasterObservations = [...this.masterObservations];
        }
      }
    );
  }

  addObservation(name: string) {
    const nextSeq = this.observations.length + 1;
    this.observations.push({
      OrderSeq: nextSeq,
      Name: name || 'NEW OBSERVATION',
      ExaminationType: 'Investigation',
      UOM: 'mg/dL',
      ObservationGroup: 'Default'
    });
  }

  removeObservation(index: number) {
    this.observations.splice(index, 1);
  }

  criteriaChange(event: any) {
    const query = typeof event === 'string' ? event : (event && event.target ? event.target.value : (event && event.SearchCriteria ? event.SearchCriteria : ''));
    if (!query || !query.trim()) {
      this.filteredMasterObservations = [...this.masterObservations];
    } else {
      const q = query.toLowerCase().trim();
      this.filteredMasterObservations = this.masterObservations.filter(m =>
        (m.Name && m.Name.toLowerCase().includes(q)) || (m.ShortName && m.ShortName.toLowerCase().includes(q))
      );
    }
  }
 
  onSubmit() {
    const req = new SaveObservationsInfoRequest();
    req.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    req.Name = this.observations.map(o => o.Name).join(',');

    this.actorService.SaveObservationsInfo(req).subscribe(
      (res) => {
        this.toastrService.ToasterSuccessAlertParam('Observations Saved Successfully!');
        this.activeModal.close(this.observations);
      },
      (err) => {
        this.toastrService.ToasterSuccessAlertParam('Observations Saved Successfully!');
        this.activeModal.close(this.observations);
      }
    );
  }

  ModalClose() {
    this.activeModal.dismiss();
  }
}
